import React from 'react';
import classnames from 'classnames';

import * as styles from './Loading.module.css';

export function Loading({immediate = false}) {
  const containerClasses = classnames(styles.Container, {
    [styles['Container-immediate']]: immediate,
  });

  return (
    <p className={containerClasses}>
      <span className={styles.Letter}>L</span>
      <span className={styles.Letter}>o</span>
      <span className={styles.Letter}>a</span>
      <span className={styles.Letter}>d</span>
      <span className={styles.Letter}>i</span>
      <span className={styles.Letter}>n</span>
      <span className={styles.Letter}>g</span>
      <span className={styles.Letter}>.</span>
      <span className={styles.Letter}>.</span>
      <span className={styles.Letter}>.</span>
    </p>
  );
}
